<template>
  <span class="oai-Badge" :class="{ 'oai-Badge-icon': iconName }">
    <AppIcon
      v-if="iconName"
      aria-hidden="true"
      class="oai-Badge_Icon"
      height="14"
      :icon-name="iconName"
      width="14"
    />
    <slot />
  </span>
</template>

<script setup>
import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'OnboardingAiBadge'
})

defineProps({
  iconName: {
    type: String,
    default: 'sparkle'
  }
})
</script>

<style lang="scss" scoped>
.oai-Badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 6px;
  border-radius: 11px;
  background: linear-gradient(90deg, #4d94ff, #8b3af3);
  font-size: $fs-12;
  line-height: 18px;
  font-weight: fw('regular');
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: $white;

  &-icon {
    padding: 2px 12px 2px 6px;
  }
}

.oai-Badge_Icon {
  flex-shrink: 0;
  color: $white;
}
</style>
